/* @flow */

import { combineReducers } from 'redux';

import marketAutocompleteReducer from './autocomplete/marketAutocompleteReducer';
import marketFilterReducer from './filter/marketFilterReducer';
import marketSearchReducer from './search/marketSearchReducer';
import marketSortReducer from './sort/marketSortReducer';
import marketTopicReducer from './topic/marketTopicReducer';
import { createFilteredReducer } from 'src/shared/core/util/reducerUtils';
import * as namespaces from 'src/shared/domain/topic/action/topicActionNamespaces';

// $FlowIssue
export default combineReducers({
  autocomplete: marketAutocompleteReducer,
  filter: marketFilterReducer,
  search: marketSearchReducer,
  sort: marketSortReducer,
  topic: createFilteredReducer(
    marketTopicReducer,
    (action) => !action.namespace || action.namespace === namespaces.ALL_TOPICS,
  ),
});
